import React, { useState } from "react";
import "../../styles/Css/Meet.css";

const MeetSection = () => {
    const [activeTab, setActiveTab] = useState('Dashboard');

    const renderTabContent = () => {
        switch (activeTab) {
            case 'Transactions':
                return (
                    <div className="meet__interface-list">
                        <div className="meet__list-item"><span>🏠 123 Oak St.</span> <strong>In Escrow</strong></div>
                        <div className="meet__list-item"><span>🏢 Sunset Loft</span> <strong>Under Review</strong></div>
                        <div className="meet__list-item"><span>🏡 Maple Drive</span> <strong>Closing</strong></div>
                    </div>
                );
            case 'Documents':
                return (
                    <div className="meet__interface-list">
                        <div className="meet__list-item"><span>📄 Purchase_Agrmt.pdf</span> <span>Signed</span></div>
                        <div className="meet__list-item"><span>📄 Disclosure_Form.pdf</span> <span className="text-warning">Pending</span></div>
                        <div className="meet__list-item"><span>📄 Inspection_Rpt.pdf</span> <span>Uploaded</span></div>
                    </div>
                );
            default: // Dashboard
                return (
                    <div className="meet__interface-body">
                        <div className="meet__interface-stat">
                            <span className="meet__interface-stat-number">12</span>
                            <span className="meet__interface-stat-label">Active Deals</span>
                        </div>
                        <div className="meet__interface-stat">
                            <span className="meet__interface-stat-number">98%</span>
                            <span className="meet__interface-stat-label">On Schedule</span>
                        </div>
                        <div className="meet__interface-stat">
                            <span className="meet__interface-stat-number">3</span>
                            <span className="meet__interface-stat-label">Closing Today</span>
                        </div>
                    </div>
                );
        }
    };
    return (
        <section className="meet section">
            <div className="container">
                <span className="meet__badge badge">WHY DEAL TO CLOSE AI?</span>
                <h2 className="section-title">Meet Deal to Close AI</h2>
                <p className="section-subtitle">
                    A smart assistant built for speed and clarity.
                </p>
                <div className="meet__visual">
                    <div className="meet__screen">
                        <div className="meet__screen-content">
                            <div className="meet__interface">
                                <div className="meet__interface-header">
                                    <div className="meet__interface-tabs">
                                        {['Dashboard', 'Transactions', 'Documents'].map((tab) => (
                                            <span
                                                key={tab}
                                                className={`meet__interface-tab ${activeTab === tab ? 'meet__interface-tab--active' : ''}`}
                                                onClick={() => setActiveTab(tab)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {tab}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                                <div className="meet__content-wrapper">
                                    {renderTabContent()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MeetSection;